import View from "../../../assets/js/view";
import { css, ajax } from "../../../assets/js/utils";

export default class Newsletter extends View {
  ui = {
    input: ".input[0]",
    button: ".button[0]",
    message: ".js-newsletterMessage[0]",
  };

  events = {
    submit: "handleSubmit",
    "keyup @ui.input": "handleInputChange",
  };

  init() {}

  handleSubmit(e) {
    e.preventDefault();
    this.ui.message.innerHTML = "";

    ajax({
      url: SITE.AJAX_URL,
      method: "POST",
      body: {
        action: "subscribe_to_newsletter",
        email: e.currentTarget.elements.email.value,
      },
    }).then((result) => {
      if (result.error) {
        this.el.classList.add("has-error");
      } else {
        this.el.classList.remove("has-error");
        this.ui.input.value = "";
      }
      this.ui.message.innerHTML = result.message;
    });
  }

  handleInputChange(e) {
    this.ui.button.classList.toggle(
      "is-hidden",
      !this.validateEmail(this.ui.input.value)
    );
  }

  validateEmail(email) {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
}
